import styled from '@emotion/styled'
import { useContext } from 'react'
import { BackButton } from './Buttons'
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi'
import { Theme } from '../../styles/settings/theme'
import { DataContext } from '../../contexts/dataContext'
import { lang } from '../../utils/lang'
import { MediaQueries as Mq } from '../../styles/settings/theme'
import { useHistory } from 'react-router-dom'

const Back = styled(BackButton)`
  position: absolute;
  bottom: 3rem;
  left: 0;

  display: ${(props) => (props.intro === 'closed' ? 'flex' : 'none')};
  p {
    margin: 0 0.25rem -0.1rem 0.25rem;
    letter-spacing: ${(props) => (props.ui === 'en' ? '0.09em' : 0)};
  }
  ${Mq.xs} {
    // top: 0.5rem;
    // right: 14rem;
    // left: unset;
    bottom: 2.5rem;
  }
`

const BackToTimeline = () => {
  const { ui, intro, setIntro, setSelections } = useContext(DataContext)
  const history = useHistory()

  const handleClick = () => {
    setIntro('open')
    const currParam = new URLSearchParams(window.location.search)
    currParam.set('intro', 'open')
    history.push(`?${currParam.toString()}`)

    setSelections({
      Religion: 'ALL',
      Occupation: 'ALL',
      Education: 'ALL',
      Gender: 'ALL',
      'Threats or failed attempts': 'ALL',
      'Modes of killing': 'ALL',
      Arrests: 'ALL',
      Prosecution: 'ALL'
    })
  }
  return (
    <Back onClick={() => handleClick()} intro={intro} ui={ui}>
      {ui === 'en' && <FiArrowLeft color={Theme.colors.white} size="16" />}
      <p>{lang[ui]['Back']}</p>
      {ui === 'fa' && <FiArrowRight color={Theme.colors.white} size="16" />}
    </Back>
  )
}

export default BackToTimeline
